import { BUTTON_TEXT, COLORS } from "./shared/shared.constants";

export const globalConstants = {
  REQUEST: "_REQUEST",
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
};

export const hubConstants = {
  FROM_HUB_KEY: "fromHub",
  FROM_HUB_VALUE: "1",
  FROM_SURVEY_VALUE: "2",
  HUB_ROOT_ELEMENT_ID: "survey-ui",
  HUB_IMAGE_PATH_ELEMENT_ID: "survey-img-path",
};

export const screenConstants = {
  GENERIC: 0,
  BRANDS: 1,
  BRAND_LOCATIONS: 2,
  GROUPS: 3,
};

export const sidebarScreenConstants = {
  PROFILE: "Profile",
  BRAND_PROFILE: "Brand Profile",
  SURVEY_QUESTIONS: "Survey Questions",
  ARCHIVED_QUESTIONS: "Archived Questions",
  SURVEY: "Survey",
  USER_NOTIFICATIONS: "User Notifications",
  THEME_SETTINGS: "Theme Settings",
  RESTAURANTS: "Brands",
  PERFORMANCE: "Performance",
  BRAND_PERFORMANCE: "Performance",
  USER_PERMISSIONS: "User Permissions",
  GROUPS: "Groups",
  MANAGERS: "Managers",
  BRAND_RESTAURANT: "Profile",
  SURVEY_RESPONSE: "Survey Response",
  GROUP_PROFILE: "Group Profile",
  GROUP_MANAGER: "Managers",
  MANAGER_PROFILE: "Manager Profile",
  MEDIUM_SCREEN_WIDTH: 768,
  ACTIVITY_LOGS: "Activity Logs",
  MARKETING_SALES: "Marketing Sales",
  CAMPAIGN_MATRICS: "Campaign Metrics",
  SURVEY_QUEUES: "Survey Queues",
  INBOX: "Inbox",
  UTILITIES: "Utilities",
  DASHBOARD: "Dashboard",
  SURVEY_MENU: "Survey ",
  MARKETING: "Marketing",
  BRAND_CONFIGURATION: "Brand Configuration",
  MARKETING_ATTRIBUTION_REPORT: "Marketing Attribution",
  MERGE_DUPLICATE_STORES: "Merge Stores",
  FEATURE_FLAGS: "Feature Flags",
  FEEDBACK: "FEEDBACK",
  REQUEST_HELP: "Request Help",
  GREETING_PREFIX: "Hi, ",
  USER_AVATAR_SIZE: 72,
  HUB_USER_AVATAR_SIZE: 75,
  HR_LOGO_WIDTH: 30,
  SIDEBAR_TOGGLE_ICON_SIZE: 20,
  DROPDOWN_DROP_END: "end",
  DROPDOWN_DROP_DOWN: "down",
};

export const validationConstant = {
  IS_VALID: "is-invalid",
};

export const screenPathsConstantsWithOutParams = {
  DASHBOARD_PATH: "/dashboard",
  GROUP_INBOX_PATH: "/group-inbox",
  BRAND_INBOX_PATH: "/stores/inbox",
  MANAGER_INBOX_PATH: "/manager-inbox",
  STORE_PROFILE_PATH: "/store-profile",
  GROUP_PROFILE_PATH: "/group-profile",
  GROUP_MANAGERS_PATH: "/group-manager",
  MANAGER_PROFILE_PATH: "/manager-profile",
  GROUP_PROFILE_PAGE: "group-profile-page",
  BRAND_GROUPS_PATH: "/stores/brand-groups",
  BRAND_PROFILE_PATH: "/stores/brand-profile",
  GROUP_PERFORMANCE_PATH: "/group-performance",
  BRAND_PERFORMANCE_PATH: "/brand-performance",
  STORE_PERFORMANCE_PATH: "/store-performance",
  DASHBOARD_FROM_STORES_PATH: "/stores/dashboard",
  GROUP_PERFORMANCE_PAGE: "group-performance-page",
  MANAGER_PERFORMANCE_PATH: "/manager-performance",
  GROUP_USER_PERMISSIONS: "/group-user-permissions",
  MANAGER_USER_PERMISSIONS: "/manager-user-permissions",
  GROUP_SURVEY_QUESTIONS_PATH: "/group-survey-questions",
  BRAND_THEME_SETTINGS_PATH: "/stores/brand-theme-settings",
  MANAGER_SURVEY_QUESTIONS_PATH: "/manager-survey-questions",
  BRAND_SURVEY_QUESTIONS_PATH: "/stores/brand-survey-questions",
  BRAND_ARCHIVED_QUESTIONS_PATH: "/stores/brand-archived-questions",
};

export const viewPathConstants = {
  ROOT: "/",
  ALL_ROUTES: "/*",
  LOGIN: "/login",
  STORES: "/stores",
  DASHBOARD: "/dashboard",
  INBOX_FROM_LOGIN: "/inbox",
  INBOX: "/stores/inbox/:brandId",
  LOGIN_EMAIL_CONFIRMATION: "/login_",
  SURVEY_RESPONSE: "/stores/survey-response",
  SURVEY_PROFILE_BY_ADMIN: "/stores/store-profile/:brandId/:locationId",
  STORE_PROFILE_FROM_LOGIN: "/stores/profile/:brandId/:locationId",
  SURVEY_PROFILE_FROM_BRAND_PROFILE:
    "/stores/brand/profile/:brandId/:locationId/store-profile",
  SURVEY_PROFILE_FROM_GROUP_PROFILE:
    "/stores/group-profile/:brandId/:locationId/store-profile",
  USER_NOTIFICATION_BY_ADMIN: "/stores/brand/user-notifications",
  USER_NOTIFICATION_BY_GROUP: "/stores/group/user-notifications",
  SURVEY_CREATION_BY_ADMIN: "/stores/brand/survey-questions/:brandId",
  SURVEY_CREATION_BY_GROUP: "/stores/group/survey-questions/:brandId",
  THEME_SETTINGS_BY_ADMIN: "/stores/brand/theme-settings/:brandId",
  BRAND_RESTAURANTS_BY_ADMIN: "/stores/brand/profile/:brandId",
  GROUP_RESTAURANTS_BY_ADMIN: "/stores/group-profile/:brandId",
  GROUPS_BY_ADMIN: "/stores/brand/groups/:brandId",
  GROUPS_BY_ADMIN_FROM_BRAND_PROFILE:
    "/stores/brand/profile/:brandId/groups/group-profile",
  USER_NOTIFICATION: "/stores/brand/user-notifications/:brandId",
  PERFORMANCE_BY_ADMIN: "/stores/performance/:brandId/:locationId",
  PERFORMANCE_BY_SUPER_ADMIN: "/stores/brand/performance/:brandId",
  PERFORMANCE_BY_BRAND_ADMIN: "/performance",
  PERFORMANCE_BY_GROUP: "/group-performance/:brandId",
  USER_PERMISSIONS_BY_ADMIN: "/stores/permissions/:brandId",
  PERFORMANCE_BY_LOCATION: "/stores/performance/:brandId/:locationId",
  CUSTOMER_SURVEY: ":encryptedParams",
  CONSUMER_RESPONSES: "/consumer-responses",
  ADD_RECIPIENTS_SINGLE_RESPONSE: "/single-response",
  ADD_RECIPIENTS_BULK_RESPONSE: "/bulk-response",
  CUSTOMER_RESPONSE:
    "/stores/performance/:brandId/:locationId/consumer-responses/:customerId",
  PREVIEW_SURVEY: "/preview-survey",
  SURVEY_PROFILE: "/profile",
  SURVEY_PROFILE_FOR_ADMIN_AND_GROUP: "/stores/store-profile",
  GROUP_PROFILE: "/stores/group/profile",
  THEME_SETTINGS: "/stores/brand/theme-settings",
  USER_PERMISSIONS: "/permissions",
  USER_PERMISSIONS_BY_BRAND: "/permissions/:brandId",
  PERFORMANCE: "/stores/performance",
  BRAND_PERFORMANCE: "/performance/:brandId",
  SURVEY_CREATION: "/stores/brand/survey-questions",
  SURVEY_CREATION_GROUP: "/stores/group/survey-questions",
  GROUP: "/stores/brand/groups",
  BRAND_RESTAURANTS: "/stores/brand/profile",
  GROUP_RESTAURANTS: "/stores/group-profile",
  LOCATION_PERFORMANCE: "/stores/performance",
  EMAIL_VERIFICATION: "/email-verification",
  GROUP_PERFORMANCE: "/group-performance",
  CONFIRM_PASSWORD: "/reset-password",
  CHANGE_SURVEY_PREFERENCES: "/change-survey-preferences",
  REDIRECTING_TO_STORE_PROFILE: "/redirecting-to-store-profile",
  REDIRECTING_TO_DEFAULT_SCREEN: "/redirecting-to-default-screen",
  UNAUTHORIZED: "/unauthorized",

  //Routes for user role
  SURVEY_PROFILE_FOR_USER: "/profile",
  SURVEY_CREATION_USER: "/survey-questions",
  LOCATION_PERFORMANCE_FOR_USER: "/performance",
  USER_NOTIFICATION_BY_USER: "/user-notifications",
  USER_SURVEY_QUESTION_BY_USER: "/survey-questions",

  // Group url for super and brand admin
  GROUP_PROFILE_URL: "/group-profile-page/:brandId/:groupId",
  GROUP_PERFORMANCE_URL: "/group-performance-page/:groupId",

  // Group routes for super and brand admin
  GROUP_PROFILE_PAGE: "/group-profile-page",
  GROUP_PERFORMANCE_PAGE: "/group-performance-page",

  SUPER_ADMIN_PERFORMANCE: "/performance",
  ACTIVITY_LOGS: "/activityLogs",

  //route for marketing super admin
  SUPER_ADMIN_CAMPAIGN_MATRICS: "/campaign-metrics",
  SUPER_ADMIN_MARKETING_SALES: "/marketing-sales",
  //route for marketing brand admin
  BRAND_ADMIN_MARKETING_SALES: "/brand-marketing-sales",
  BRAND_ADMIN_CAMPAIGN_METRICS: "/brand-campaign-metrics",
};

export const pathConstant = {
  BRAND: "brand",
  GROUP: "group",
  FEATURE: "feature",
  MANAGER: "manager",
  STORES: "stores",
  DASHBOARD: "dashboard",
  PERFORMANCE: "performance",
  USER_PROFILE: "userProfile",
  BRAND_PROFILE: "brand-profile",
  GROUP_PROFILE: "group-profile",
  GROUP_MANAGER: "group-managers",
  MANAGER_PROFILE: "manager-profile",
  STORE_GROUP: "store-group",
  UPDATE_STORE_FEATURES: "update-store-features",

  MANAGER_PERFORMANCE: "manager-performance",
  GROUP_PERFROMANCE: "group-performance",
  STORE_PERFORMANCE: "store-performance",
  STORE_BRAND_PROFILE: "store-brand-profile",
  BRAND_SURVEY_QUESTIONS: "brand-survey-questions",
  GROUP_SURVEY_QUESTIONS: "group-survey-questions",
  MANAGER_SURVEY_QUESTIONS: "manager-survey-questions",

  GET_BRAND_SOCIAL_LINKS: "get-brand-social-links",
  UPDATE_BRAND_SOCIAL_LINKS: "update-brand-social-links",
  GET_ALL_BRANDS_FOR_AI_REPLY: "get-all-brands-for-ai-reply",
};

export const Roles = {
  USER: "User",
  GROUP: "Group",
  MANAGER: "Manager",
  BRANDADMIN: "BrandAdmin",
  SUPERADMIN: "SuperAdmin",
};

export const reactSelectStylingConst = {
  boxShadow: "none",
  minHeight: "2.3rem",
  borderRadius: "6px",
  blackColor: COLORS.BLACK,
  grayColor: COLORS.GRAY,
  scarlet: COLORS.SCARLET,
  ashGrey: COLORS.ASH_GREY,
  mutedGrey: COLORS.MUTED_GREY,
  teal: COLORS.TEAL,
  transparentColor: "transparent",
};

export const MENU_PLACEMENT = {
  AUTO: "auto",
  BOTTOM: "bottom",
  TOP: "top",
};

// Super admin routes
export const adminPath = {
  STORES: "/stores",
  USER_PROFILE: "/userProfile",
  SURVEY_QUEUES: "/survey-queues",
  MARKETING_SALES: "/marketing-sales",
  CAMPAIGN_MATRICS: "/campaign-metrics",
  DASHBOARD: "/stores/dashboard/:brandId",
  MARKETING_ATTRIBUTION: "/stores/marketing-attribution/:brandId",
  PROCESSED_MARKETING_ATTRIBUTION:
    "/stores/processed-marketing-attribution/:brandId",
  RESTAURANTS_PERFORMANCE: "/performance",
  RESTAURANTS_ACTIVITY_LOGS: "/activityLogs",
  RESTAURANTS_USER_PERMISSIONS: "/permissions",
  DASHBOARD_BY_GROUP_ADMIN: "/dashboard/:groupId",
  RESTAURANTS_BRAND_CONFIGURATION: "/brand-configuration",
  RESTAURANTS_BRAND_PROFILE: "/stores/brand-profile/:brandId",
  RESTAURANTS_BRAND_PERFORMANCE: "/stores/dashboard/:brandId/brand-performance",
  RESTAURANTS_BRAND_GROUPS: "/stores/brand-groups/:brandId",
  RESTAURANTS_BRAND_THEME_SETTINGS: "/stores/brand-theme-settings/:brandId",
  RESTAURANTS_BRAND_SURVEY_QUESTIONS: "/stores/brand-survey-questions/:brandId",
  RESTAURANTS_BRAND_ARCHIVED_QUESTIONS:
    "/stores/brand-archived-questions/:brandId",
  RESTAURANTS_BRAND_USER_NOTIFICATION:
    "/stores/brand-user-notifications/:brandId",
  // Stores profile and performance
  RESTAURANTS_RESTAURANT_PROFILE: "/stores/:brandId/store-profile/:locationId",
  RESTAURANTS_RESTAURANT_PERFORMANCE:
    "/stores/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_BRAND_GROUPS:
    "/stores/brand-groups/:brandId/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_BRAND_GROUPS:
    "/stores/brand-groups/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_BRAND_PERFORMANCE:
    "/stores/dashboard/:brandId/brand-performance/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_BRAND_PERFORMANCE:
    "/stores/dashboard/:brandId/brand-performance/store-performance/:locationId",
  // Group profile and performance
  GROUP_PROFILE_BY_RESTAURANT_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/group-profile-page/:groupId",
  GROUP_PROFORMANCE_BY_RESTAURANT_BRAND_PROFILE:
    "/stores/dashboard/:brandId/brand-profile/group-performance-page/:groupId",
  GROUP_PROFILE_BY_RESTAURANT_BRAND_PERFORMANCE:
    "/stores/dashboard/:brandId/brand-performance/group-profile-page/:groupId",
  GROUP_PROFORMANCE_BY_RESTAURANT_BRAND_PERFORMANCE:
    "/stores/dashboard/:brandId/brand-performance/group-performance-page/:groupId",
  // Consumer responses
  CONSUMER_RESPONSES_BY_RESTAURANTS:
    "/stores/:brandId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_GROUPS:
    "/stores/brand-groups/:brandId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_RESTAURANT_BRAND_PERFORMANCE:
    "/stores/dashboard/:brandId/brand-performance/store-performance/:locationId/consumer-responses/:customerId",
  MERGE_DUPLICATE_STORES: "/merge-duplicate-stores",
  FEATURE_FLAGS: "/feature-flags",
  GET_BRAND_REPORT: "/get-brand-report",
};

// Brand admin path
export const brandAdminPath = {
  STORES: "/stores",
  USER_PROFILE: "/userProfile",
  BRAND_USER_PERMISSIONS: "/permissions",
  BRAND_PROFILE: "/stores/brand-profile/:brandId",
  BRAND_GROUPS: "/stores/brand-groups/:brandId",
  BRAND_MARKETING_SALES: "/brand-marketing-sales",
  BRAND_CAMPAIGN_METRICS: "/brand-campaign-metrics",
  BRAND_PERFORMANCE: "/brand-performance/:brandId",
  BRAND_THEME_SETTINGS: "/stores/brand-theme-settings/:brandId",
  BRAND_SERVEY_QUESTIONS: "/stores/brand-survey-questions/:brandId",
  BRAND_ARCHIVED_QUESTIONS: "/stores/brand-archived-questions/:brandId",
  BRAND_USER_NOTIFICATION: "/stores/brand-user-notifications/:brandId",
  // Group profile and performance
  GROUP_PROFILE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/group-profile-page/:groupId",
  GROUP_PROFILE_BY_PERFORMANCE:
    "/stores/brand-performance/:brandId/group-profile-page/:groupId",
  GROUP_PERFORMANCE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/group-performance-page/:groupId",
  GROUP_PERFORMANCE_BY_PERFORMANCE:
    "/stores/brand-performance/:brandId/group-performance-page/:groupId",
  // Stores profile and performance
  RESTAURANT_PERFORMANCE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_GROUP:
    "/stores/brand-groups/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_GROUP:
    "/stores/brand-groups/:brandId/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_PERFORMANCE:
    "/stores/brand-performance/:brandId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_PERFORMANCE:
    "/stores/brand-performance/:brandId/store-profile/:locationId",
  // Consumer responses
  CONSUMER_RESPONSES_BY_BRAND_PROFILE:
    "/stores/brand-profile/:brandId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_GROUP:
    "/stores/brand-groups/:brandId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_PERFORMANCE:
    "/stores/brand-performance/:brandId/store-performance/:locationId/consumer-responses/:customerId",
};

// Group admin path
export const groupAdminPath = {
  DASHBOARD_BY_GROUP_ADMIN: "/dashboard/:groupId",
  GROUP_PROFILE: "/group-profile/:groupId",
  GROUP_INBOX: "/group-inbox/:groupId",
  SETTING: "/group-setting/:groupId/setting",
  GROUP_USER_MANAGERS: "/group-manager/:groupId",
  USER_PROFILE: "/dashboard/:groupId/userProfile",
  GROUP_PERFORMANCE: "/dashboard/:groupId/group-performance",
  GROUP_USER_PERMISSIONS: "/group-user-permissions/:groupId",
  GROUP_SURVEY_QUESTIONS: "/group-survey-questions/:groupId",
  GROUP_USER_NOTIFICATION: "/group-user-notifications/:groupId",
  // Stores profile and performance
  STORE_PERFORMANCE_BY_GROUP_PROFILE:
    "/group-profile/:groupId/store-performance/:locationId",
  STORE_PROFILE_BY_GROUP_PROFILE:
    "/group-profile/:groupId/store-profile/:locationId",
  STORE_PERFORMANCE_BY_GROUP_MANAGERS:
    "/group-manager/:groupId/store-performance/:locationId",
  STORE_PROFILE_BY_GROUP_MANAGERS:
    "/group-manager/:groupId/store-profile/:locationId",
  STORE_PERFORMANCE_BY_PERFORMANCE:
    "/dashboard/:groupId/group-performance/store-performance/:locationId",
  STORE_PROFILE_BY_PERFORMANCE:
    "/dashboard/:groupId/group-performance/store-profile/:locationId",
  // Consumer responses
  CONSUMER_RESPONSES_BY_GROUP_PROFILE:
    "/group-profile/:groupId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_GROUP_MANAGERS:
    "/group-manager/:groupId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_PERFORMANCE:
    "/dashboard/:groupId/group-performance/store-performance/:locationId/consumer-responses/:customerId",
  MARKETING_ATTRIBUTION: "/marketing-attribution/:groupId",
};

// Manger admin path
export const managerAdminPath = {
  MANAGER_INBOX: "/manager-inbox/:managerId",
  MANAGER_PROFILE: "/manager-profile/:managerId",
  MANAGER_SERVEY_QUESTIONS: "/manager-survey-questions/:managerId",
  MANAGER_USER_NOTIFICATION: "/manager-user-notifications/:managerId",
  MANAGER_PERFORMANCE: "/dashboard/:managerId/manager-performance",
  MANAGER_USER_PERMISSIONS: "/manager-user-permissions/:managerId",
  // Stores profile and performance
  RESTAURANT_PERFORMANCE_BY_MANAGER_PROFILE:
    "/manager-profile/:managerId/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_MANAGER_PROFILE:
    "/manager-profile/:managerId/store-profile/:locationId",
  RESTAURANT_PERFORMANCE_BY_PERFORMANCE:
    "/dashboard/:managerId/manager-performance/store-performance/:locationId",
  RESTAURANT_PROFILE_BY_PERFORMANCE:
    "/dashboard/:managerId/manager-performance/store-profile/:locationId",
  // Consumer responses
  CONSUMER_RESPONSES_BY_MANAGER_PROFILE:
    "/manager-profile/:managerId/store-performance/:locationId/consumer-responses/:customerId",
  CONSUMER_RESPONSES_BY_PERFORMANCE:
    "/dashboard/:managerId/manager-performance/store-performance/:locationId/consumer-responses/:customerId",

  USER_PROFILE: "/dashboard/:managerId/userProfile",
  DASHBOARD_BY_MANAGER_ADMIN: "/dashboard/:managerId",
};

//Constants for exluded path for breadcrumbs
export const excludePaths = [
  "/",
  // brand admin path exclude
  "/brand-profile",
  "/brand-groups",
  "/brand-theme-settings",
  "/brand-survey-questions",
  "/brand-archived-questions",
  "/brand-user-notifications",
  "/brand-performance",
  "/brand-user-permissions",
  "/brand-profile/:brandId",
  "/brand-profile/:brandId/group-performance-page",
  "/brand-performance/:brandId/group-performance-page",
  "/brand-performance/:brandId/group-profile-page",
  "/brand-profile/:brandId/group-profile-page",
  "/brand-profile/:brandId/store-performance",
  "/brand-profile/:brandId/store-profile",
  "/brand-groups/:brandId/store-profile",
  "/brand-groups/:brandId/store-performance",
  "/brand-performance/:brandId/store-profile",
  "/brand-performance/:brandId/store-performance",
  "/brand-profile/:brandId/store-performance/:locationId/consumer-responses",
  "/brand-groups/:brandId/store-performance/:locationId/consumer-responses",
  "/brand-performance/:brandId/store-performance/:locationId/consumer-responses",
  // group admin path exclude
  "/group-manager",
  "/group-setting",
  "/group-profile",
  "/group-performance",
  "/group-user-permissions",
  "/group-survey-questions",
  "/group-user-notifications",
  "/group-profile/:brandId/store-profile",
  "/group-manager/:brandId/store-profile",
  "/group-profile/:brandId/store-performance",
  "/group-manager/:brandId/store-performance",
  "/group-performance/:brandId/store-profile",
  "/group-performance/:brandId/store-performance",
  "/group-profile/:brandId/store-performance/:locationId/consumer-responses",
  "/group-manager/:brandId/store-performance/:locationId/consumer-responses",
  "/group-performance/:brandId/store-performance/:locationId/consumer-responses",
  // user admin path exclude
  "/user-profile",
  "/user-performance",
  "/user-notifications",
  "/user-survey-questions",
  "/user-profile/:brandId",
  "/user-performance/:brandId",
  "/user-notifications/:brandId",
  "/user-survey-questions/:brandId",
  "/user-performance/:brandId/:locationId/consumer-responses",
  // super admin path exclude
  "/stores/:brandId",
  "/stores/brand-profile",
  "/stores/brand-groups",
  "/stores/brand-performance",
  "/stores/brand-theme-settings",
  "/stores/brand-survey-questions",
  "/stores/brand-user-notifications",
  "/stores/:brandId/store-profile",
  "/stores/:brandId/store-performance",
  "/stores/brand-profile/:brandId/group-profile-page",
  "/stores/brand-profile/:brandId/store-profile",
  "/stores/brand-groups/:brandId/store-profile",
  "/stores/brand-performance/:brandId/store-profile",
  "/stores/brand-performance/:brandId/group-profile-page",
  "/stores/brand-profile/:brandId/group-performance-page",
  "/stores/brand-profile/:brandId/store-performance",
  "/stores/brand-groups/:brandId/store-performance",
  "/stores/brand-performance/:brandId/group-performance-page",
  "/stores/brand-performance/:brandId/store-performance",
  "/stores/:brandId/store-performance/:locationId/consumer-responses",
  "/stores/brand-profile/:brandId/store-performance/:locationId/consumer-responses",
  "/stores/brand-groups/:brandId/store-performance/:locationId/consumer-responses",
  "/stores/brand-performance/:brandId/store-performance/:locationId/consumer-responses",

  //Manager role exluded paths
  "/manager-profile",
  "/manager-performance",
  "/manager-user-permissions",
  "/manager-survey-questions",
  "/manager-profile/:brandId/store-profile",
  "/manager-profile/:brandId/store-performance",
  "/manager-performance/:brandId/store-profile",
  "/manager-performance/:brandId/store-performance",
  "/manager-profile/:brandId/store-performance/:locationId/consumer-responses",
  "/manager-performance/:brandId/store-performance/:locationId/consumer-responses",

  "/inbox",
  "/group-inbox",
  "/manager-inbox",
  "/group-inbox/:groupId/consumer-responses",
  "/stores/inbox/:brandId/consumer-responses",
  "/manager-inbox/:managerId/consumer-responses",
  "/group-inbox/:groupId/consumer-responses/:locationId",
  "/stores/inbox/:brandId/consumer-responses/:locationId",
  "/manager-inbox/:managerId/consumer-responses/:locationId",

  "/dashboard",
  "/marketing-attribution",
  "/stores/dashboard/:brandId/brand-performance/store-performance",
  "/stores/dashboard/:brandId/brand-performance/store-profile",
  "/stores/dashboard/:brandId/brand-performance/store-performance/:locationId/consumer-responses",

  "/dashboard/:groupId/group-performance/store-performance",
  "/dashboard/:groupId/group-performance/store-profile",
  "/dashboard/:groupId/group-performance/store-performance/:locationId/consumer-responses",

  "/dashboard/:managerId/manager-performance/store-performance",
  "/dashboard/:managerId/manager-performance/store-profile",
  "/dashboard/:managerId/manager-performance/store-performance/:locationId/consumer-responses",

  "/stores/dashboard/:brandId/brand-performance/group-performance-page",
  "/stores/dashboard/:brandId/brand-performance/group-profile-page",
];

//Constant for not Applicable
export const NOT_APPLICABLE = "N/A";

//Constant or null data
export const NULL_DATA_HYPHEN = "-";

//System Green color constant
export const systemGreenColor = "#0E8476";

//image formats for uploading
export const ACCEPTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];
//error message for image uploading
export const ERROR_LOADING_IMAGE = "Error loading image.";

//Maximum message size in mbs for sending message in survey inbox
export const MAXIMUM_MESSAGE_SIZE = 25;

export const MESSAGE_SIZE_CONVERSION = {
  BYTES_PER_MEGABYTE: 1024 * 1024,
};

export const MESSAGE_SIZE_DISPLAY = {
  DECIMAL_PLACES: 2,
  SIZE_LABEL: "Size",
  MEGABYTE_UNIT_LABEL: "MB",
};

//Enivroment Name
export const enviromentNamesConstants = {
  STAGING: "STAGING",
  DEVELOPMENT: "development",
};

//Screen sizes
export const screenSize = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1200,
  LAYOUT_DESKTOP: 786,
  LAYOUT_MOBILE: 787,
};
// Modal sizes
export const modalSize = {
  MODAL_SIZE_SMALL: "sm",
  MODAL_SIZE_MEDIUM: "md",
  MODAL_SIZE_LARGE: "lg",
};

export const modalButtonText = {
  NO: BUTTON_TEXT.NO,
  YES: BUTTON_TEXT.YES,
};

// Image dimensions
export const imagePreviewDimensions = {
  IMAGE_PREVIEW_WIDTH: 30,
  IMAGE_PREVIEW_HEIGHT: 30,
};

// Table Constants used in width, height, size of columns
export const tableColumns = {
  SIZE_10: 10,
  SIZE_20: 20,
  SIZE_30: 30,
  SIZE_40: 40,
  SIZE_50: 50,
  SIZE_60: 60,
  SIZE_70: 70,
  SIZE_80: 80,
  SIZE_90: 90,
  SIZE_100: 100,
  SIZE_110: 110,
  SIZE_120: 120,
  SIZE_130: 130,
  SIZE_140: 140,
  SIZE_150: 150,
  SIZE_160: 160,
  SIZE_170: 170,
  SIZE_180: 180,
  SIZE_190: 190,
  SIZE_200: 200,
  SIZE_210: 210,
  SIZE_300: 300,
  SIZE_600: 600,
  SIZE_680: 680,
  SIZE_8REM: "8rem",
};

export const OLD_STORE_ID = 10304;
export const NEW_STORE_ID = 10308;

export const BRANDS = "Brand";
export const HIDE_QUESTION = "HideQuestion";
export const STORES_BY_GROUP_ID = "storesByGroupId";
export const STORES_BY_MANAGER_ID = "storesByManagerId";
export const BRAND_AVERAGE_RATING = "brandAverageRating";
export const GROUPS_AVERAGE_RATING = "groupsAverageRating";
export const MANAGERS_AVERAGE_RATING = "managersAverageRating";
export const UPDATE_ORDER_TYPE_CATEGORIES = "UpdateOrderTypeCategories";
export const GET_ALL_ORDER_TYPE_CATEGORIES = "GetAllOrderTypeCategories";

export const PRIVACY_POLICY_LINK = "https://www.hungerrush.com/privacy-policy";
